export function generateUUID() {
	let first = 'xxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});

	return first += (Math.random() * 10).toFixed(8).toString();
}

export class ValidationUtils {
	public static validateString(val) {
		val = val && typeof val == 'string' ? val : null;
		val = val ? val.trim() : false;
		return val;
	}
}


export function generateRandomAttachmentsUUID() {
	return 'xxxxxxxxxxxxxx.xxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

export function isBrowser() {

	var cordova = (window as any).cordova;
	var platform = (window as any).Ionic.platform;

	if (platform.is("android") || platform.is("ios") || platform.is("ipad")) {

		if (cordova && cordova.platformId == "browser") {
			return true;
		}

		return false;

	} else {
		return true;
	}

}

export function formatDate(datestring) {
	let date;
	if (datestring == '' || datestring == undefined) {
		date = new Date();
	}
	else {
		// var date = new Date(datestring);
		date = new Date(Date.parse(datestring.replace(/-/g, '/').replace(/[a-z]+/gi, ' ')))
	}
	var hours: any = date.getHours();
	var minutes: any = date.getMinutes();
	var day: any = date.getDate();
	var month: any = date.getMonth() + 1;
	day = day < 10 ? '0' + day : day;
	month = month < 10 ? '0' + month : month;
	hours = hours < 10 ? '0' + hours : hours;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	var strTime = hours + ':' + minutes;

	return day + "/" + month + "/" + date.getFullYear() + " " + strTime;
}

export function toDBDate() {
	var date = new Date();
	var hours: any = date.getHours();
	var minutes: any = date.getMinutes();
	var day: any = date.getDate();
	var month: any = date.getMonth() + 1;
	var seconds: any = date.getSeconds();
	day = day < 10 ? '0' + day : day;
	month = month < 10 ? '0' + month : month;
	hours = hours < 10 ? '0' + hours : hours;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	seconds = seconds < 10 ? '0' + seconds : seconds;
	var strTime = hours + ':' + minutes + ':' + seconds;
	return date.getUTCFullYear() + "-" + month + "-" + day + " " + strTime;
}


export function getEventDate(date: Date) {
	var date = date ? date : new Date();
	var day: any = date.getDate();
	var month: any = date.getMonth() + 1;
	day = day < 10 ? '0' + day : day;
	month = month < 10 ? '0' + month : month;
	return date.getFullYear() + "-" + month + "-" + day;
}

export function getEventTime(date: Date) {
	var hours: any = date.getHours();
	var minutes: any = date.getMinutes();
	hours = hours < 10 ? '0' + hours : hours;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	return hours + ":" + minutes; 
}

export function areArraysSame(array1, array2) {
	return (array1.length == array2.length) && array1.every(function (element, index) {
		return element === array2[index];
	});
}

export function removePTags(target) {
	if (target) {
		var t = target.replace(new RegExp('<p>', 'g'), '');
		t = t.replace(new RegExp('</p>', 'g'), '');
		return t;
	}
	else
		return target;

}


export function convertFileToBase64(fileImage: File): Promise<{}> {

	return new Promise((resolve, reject) => {
		let fileReader: FileReader = new FileReader();
		if (fileReader && fileImage != null) {
			fileReader.readAsDataURL(fileImage);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		} else {
			reject(new Error('No file found'));
		}
	});
}



// WEBPACK FOOTER //
// ./src/Utils/CommonUtils.ts